import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Card } from "@mui/material";
import Charts from "./Charts";
import DashboardMetrics from "./DashboardMetrics";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import Header from "../../../components/header";
import axiosInstance from "../../../services/axiosInterceptors";
import Alert from "@mui/material/Alert";
import Loader from "../../../components/AnimatedLoader";
import CommonFilter from "../../../components/CommonFilter";
import moment from "moment";
import { palette, theme as colorTheme } from "../../../Convoze.theme";
import ParentWrapper from "../../../components/ParentWrapper";
import { jwtDecode } from "jwt-decode";
const today = moment();

function DashBoard() {
  const [cardDetails, setCardDetails] = useState({});
  const [payloadData, setPayloadData] = useState();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";

  const isFilter = {
    date: true,
    filter: true,
    callDuration: true,
    callScore:
      decodedToken?.companyId == "67e560a6ae2e0d3f96b5eb09" ? true : false,
  };

  useEffect(() => {
    const today = new Date();
    const data = {
      startDate: payloadData?.filters?.startDate
        ? payloadData?.filters?.startDate
        : today?.toISOString().split("T")[0],
      endDate: payloadData?.filters?.endDate
        ? payloadData?.filters?.endDate
        : today?.toISOString().split("T")[0],
      agentName:
        payloadData?.filters?.agents?.length > 0
          ? payloadData?.filters?.agents
          : [],
      sentiment:
        payloadData?.filters?.sentiment?.length > 0
          ? payloadData?.filters?.sentiment
          : [],
      campaign:
        payloadData?.filters?.campaigns?.length > 0
          ? payloadData?.filters?.campaigns
          : [],
      callDurationText:
        payloadData?.filters?.callDuration?.length > 0
          ? payloadData?.filters?.callDuration
          : [],
      callDirection: payloadData?.filters?.callInteraction
        ? payloadData?.filters?.callInteraction
        : "",
      disposition:
        payloadData?.filters?.disposition?.length > 0
          ? payloadData?.filters?.disposition
          : [],
      subDisposition:
        payloadData?.filters?.subDisposition?.length > 0
          ? payloadData?.filters?.subDisposition
          : [],
      callScore: payloadData?.filters?.callScore?.length
        ? payloadData.filters.callScore
        : [],
    };

    fetchDashboardDetails(data);
  }, [payloadData]);

  const fetchDashboardDetails = async (data) => {
    try {
      const res = await axiosInstance.post(
        apiEndPointsConfig?.dashboard,
        data,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setCardDetails(res?.data?.data);
      setLoading(false);
    } catch (error) {
      const statusCode = error?.response?.data?.status?.code;
      if (statusCode === 401) {
        localStorage.clear();
      } else {
        console.error("Dashboard fetch error:", error);
      }
    }
  };

  return (
    <ParentWrapper>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <CommonFilter
          setPayloadData={setPayloadData}
          storageName={"managerDashboard"}
          isFilter={isFilter}
        />
      </Box>
      <Box>
        <DashboardMetrics cardDetails={cardDetails?.sentimentData} />
        {loading ? <Loader /> : <Charts cardDetails={cardDetails} />}
      </Box>
    </ParentWrapper>
  );
}

export default DashBoard;
